import React, { useState } from 'react'
import ProjectApi from '../../../api/Corporates/Projects'
import Dashboard from '../../../components/Project/Projects/Dashboard'
import _, { get } from 'lodash'
import { withRouter } from 'react-router-dom'
import omitEmpty from 'omit-empty'
import moment from 'moment'
import { message } from 'antd'
import Files from '../../../api/Files'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { arrVal } from '../../../modules/Utils'
import useTitle from '../../../elements/Hooks/useTitle'

const api = new ProjectApi()
const filesApi = new Files()

function DashboardCont(props) {
  const { projectId, key } = props.match.params
  const [VisibleTemplate, setVisibleTemplate] = useState(false)
  const [updating, setUpdating] = useState(false)
  const { object: project, fetching, fetch } = useFetchObject(() => api.get(projectId))
  useTitle(`${project.code || 'Loading ...'}`)

  const groupID = _.replace(project.group, 'groups/', '')
  let { list: templatesLists, fetch: fetchTemplate } = useFetchList(api.listTemplates)
  templatesLists = arrVal(templatesLists, 'group.template')
  let { list: teamMembers, fetch: fetchMember, fetching: fetchingMember } = useFetchList(() =>
    api.getGroupsWithMembers(groupID)
  )
  teamMembers = _.get(teamMembers, '0.members') || []
  let template =
    _.get(
      templatesLists.find((t) => {
        return t.key === get(project, 'project.template')
      }),
      'document'
    ) || []
  const onShowTemplate = () => {
    setVisibleTemplate(true)
  }
  const onCancelTemplate = () => {
    fetchTemplate()
    setVisibleTemplate(false)
  }
  const handleUpload = async (filesWithMeta) => {
    const { projectId } = props.match.params
    setUpdating(true)
    const formData = new FormData()
    let metaCollection = []
    filesWithMeta.map((fileAndMeta) => {
      const fileList = fileAndMeta.files
      const template = fileAndMeta.template
      if (fileList && template) {
        let data = {
          meta: omitEmpty({
            folder: `projects/${projectId}`,
            timestamp: moment().utc().format(),
            name: template.label,
            description: `${project.project.title} - ${template.desc}`,
            email: false,
            category: 'Required Document',
          }),
        }

        fileList.forEach((file) => {
          formData.append('upload', file.originFileObj)
          data.meta.uid = file.uid
          metaCollection.push(data)
        })
      }
    })
    metaCollection = JSON.stringify(metaCollection)
    formData.append('meta', metaCollection)
    try {
      let results = await filesApi.uploadBulk(formData)
      results && message.success('Uploaded!')
      results &&
        (await api.requiredDocumentAppendToProject({
          key: projectId,
          files: results,
        }))
      fetch()
      onCancelTemplate()
    } catch (error) {
      onCancelTemplate()
      message.error(error.errorMessage)
    }
    setUpdating(false)
  }

  return (
    <Dashboard
      {...{
        groupID,
        key,
        updating,
        fetching,
        templatesLists,
        template,
        fetch,
        fetchMember,
        fetchingMember,
        teamMembers,
        fetchTemplate,
        VisibleTemplate,
        project,
        onShowTemplate,
        onCancelTemplate,
        handleUpload,
      }}
    />
  )
}

export default withRouter(DashboardCont)
